// extracted by mini-css-extract-plugin
export var arrows = "_1m-6";
export var decrementer = "_1m-a";
export var disabled = "_1m-4";
export var error = "_1m-1";
export var hiddenText = "_1m-b";
export var incrementer = "_1m-9";
export var input = "_1m-8";
export var inputWrapper = "_1m-0";
export var leadingIcon = "_1m-c";
export var readonly = "_1m-3";
export var regular = "_1m-7";
export var small = "_1m-5";
export var warning = "_1m-2";